import React, { useMemo } from "react";
import PropTypes from "prop-types";
import { Grid } from "@mui/material";
import { useTranslation } from "react-i18next";

const ActivityFieldsSummary = ({ partnerActivityFieldsSummary }) => {
  const { t } = useTranslation();

  const caenCode = useMemo(() => {
    if (!partnerActivityFieldsSummary) return "";
    if (!partnerActivityFieldsSummary.code && !partnerActivityFieldsSummary.name) return "";
    return `${partnerActivityFieldsSummary.code} ${partnerActivityFieldsSummary.name}`;
  }, [partnerActivityFieldsSummary]);

  return (
    <Grid container spacing={1} pt="1" sx={{ fontSize: "14px" }}>
      <Grid item xs={12}>
        <strong>{t("ActivityFields.CAENCode")}</strong> : <span>{caenCode}</span>
      </Grid>
    </Grid>
  );
};

ActivityFieldsSummary.propTypes = {
  partnerActivityFieldsSummary: PropTypes.object
};

export default ActivityFieldsSummary;
